import stat from './stat.js'

stat.init()